import { request } from '@/utils/http'
export default{
    getTestItem: (params = {}) => request.get('/test-items',{params})
}